module.exports = {
  DEFAULT: {
    maxContentWidth: '980px',
  },
};
